export default "__VITE_ASSET__DiLigTNw__"